import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseToggleSwitchComponent } from 'app/components/ui-kit/inputs/base-toggle-switch/base-toggle-switch.component';

@Component({
  selector: 'app-toggle-switch-card',
  standalone: true,
  imports: [CommonModule, BaseToggleSwitchComponent],
  templateUrl: './toggle-switch-card.component.html',
  styleUrl: './toggle-switch-card.component.scss'
})
export class ToggleSwitchCardComponent {
  @Input() checked: boolean = false;
  @Input() headerText: string = 'Missing Header Text';
  @Input() descriptiveText: string = 'Missing Descriptive Text';
  @Output() toggled = new EventEmitter<boolean>();

  handleToggle() {
    this.toggled.emit();
  }
}
